/**
 * Google OAuth credentials interface
 */
export interface GoogleOAuthCredentials {
  clientId: string;
  clientSecret: string;
}

/**
 * Get Google OAuth credentials - using Joules credentials for all tenants
 * This unifies the OAuth system across all tenants as per email integration unification plan
 */
export const getGoogleOAuthCredentials = async (): Promise<GoogleOAuthCredentials> => {
  // Use Joules credentials for all tenants (unified OAuth system)
  const clientId = import.meta.env.VITE_JOULES_GOOGLE_CLIENT_ID;
  const clientSecret = import.meta.env.VITE_JOULES_GOOGLE_CLIENT_SECRET;
  
  if (!clientId || !clientSecret) {
    throw new Error('Joules Google OAuth credentials not configured. Please check VITE_JOULES_GOOGLE_CLIENT_ID and VITE_JOULES_GOOGLE_CLIENT_SECRET environment variables.');
  }
  
  return { clientId, clientSecret };
};

// CLN-6.10 removed `getGoogleOAuthCredentialsSync`. It had ZERO callers, and its only
// parameter was an `isSolerroTenant` flag its own doc comment described as unused.
// The async version above already returns Joules credentials for every account.
